import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const CategoryServices = {
  categoryList: async () => {
    const response = await apiService.get("/category");
    return response.data;
  },
  subcategoryList: async ({ pageSize = 10, pageNumber = 1 }) => {
    const response = await apiService.get(
      `/category?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return response.data;
  },

  maincategoryList: async () => {
    const response = await apiService.get("/category");
    return response.data;
  },
  // maincategory: async ({
  //   name = "",
  //   pageNumber = 1,
  //   pageSize = 10,
  //   Status = null, // Use Status as the parameter
  // } = {}) => {
  //   const params = new URLSearchParams({
  //     ...(name && { name }),
  //     pageNumber: pageNumber.toString(),
  //     pageSize: pageSize.toString(),
  //     ...(Status !== null && { Status: Status.toString() }), // Include Status if provided
  //   });

  //   const response = await apiService.get(`/category?${params.toString()}`);
  //   return response.data;
  // },

  maincategory: async ({
    name = "",
    pageNumber = 1,
    pageSize = 1000,
    Status = null,

  } = {}) => {
    const params = new URLSearchParams({
      ...(name && { name }),
      Page: pageNumber.toString(),
      PageSize: pageSize.toString(),
      ...(Status !== null && { Status: Status.toString() }),
    });

    const response = await apiService.get(`/category?${params.toString()}`);
    return response.data;
  },

  categorycreate: async (postData) => {
    try {
      const response = await apiService.post("/category", postData);
      return response.data;
    } catch (error) {
      console.error("Error creating:", error);
      throw error;
    }
  },
  viewcategory: async (id) => {
    const response = await apiService.get(`/category/${id}`);
    return response.data;
  },
  deletecategory: async (id) => {
    const response = await apiService.delete(`/category/${id}`);
    return response.data;
  },
  categoryUpdate: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/category/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },

  viewitems: async (id) => {
    const response = await apiService.get(`/items/itemdetail/${id}`);
    return response.data;
  },
};

export default CategoryServices;
